<template>
  <div class="inscriptions">
    <b-container fluid>
      <b-row>
        <h1>Inscriptions</h1>
      </b-row>
      <b-row>
        <b-button 
          variant="primary"
          @click="showModal('create-inscription')">
          Add a new inscription
        </b-button>
      </b-row>
      <b-row>
        <b-table 
          id="table-inscriptions"
          hover
          :fields="inscription_fields"
          :filter="filterCriteria"
          :filter-included-fields="filterOn"
          :items="displayed_inscriptions"
          :per-page="perPage"
          :current-page="currentPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          small
          class="mt-3">

        <template #cell(sales)="row">
          {{ row.item.sales.name }}
        </template>

        <template #cell(actions)="row" align-h="center">
          <b-button size="sm" @click="showDetails(row.item.id)"> Details </b-button>
        </template>
          
        </b-table>
      </b-row>
    </b-container>

    <b-modal id="create-inscription" hide-footer title="Create an inscription">
      <b-container>
        <b-row>
          <b-col cols="6">
            <label for="new_order_number">Order number:</label>
            <input type="text" id='new_order_number' v-model="new_order_number" class="form-control">
          </b-col>
          <b-col cols="6">
            <label for="order_date">Order date:</label>
            <p id='order_date' class="form-control">{{order_date}}</p>
          </b-col>
        </b-row>
      </b-container>
      <div class="mt-2 align-right">
        <b-button @click="hideModal('create-inscription')"> Cancel </b-button>
        <b-button class="ml-1" variant="primary" @click="createInscription()"> Create </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  name: 'Inscriptions',
  data() {
    return {
      new_order_number: '',
      order_date: '',
      inscription_fields: [
        {key: 'sales', label: 'Sales'},
        {key: 'order_number', label: 'Order#'},
        {key: 'deposit_date', label: 'Deposit'},
        {key: 'request_proof_date', label: 'Request Proof'},
        {key: 'comfirm_proof_date', label: 'Proof Back'},
        {key: 'customer_sign_date', label: 'Proof Signed by Customer'},
        {key: 'sent_signed_proof_date', label: 'Signed Proof Sent'},
        {key: 'complete_date', label: 'Job Complete'},
        {key: 'status', label: 'Status'},
        {key: 'actions', label: 'actions'},
      ],
      filterCriteria: 'active',
      filterOn: ['status'],
      displayed_inscriptions: [],
      all_inscriptions: [],
      perPage: 6,
      currentPage: 1,
      sortBy: "order_date",
      sortDesc: false,
    };
  },
  props: {
    user: Object
  },
  created() {
    firebase.firestore().collection('inscriptions').where("sales.id","==",this.user.id).onSnapshot((collection) => {
      this.all_inscriptions = collection.docs.map(doc => doc.data());
      this.displayed_inscriptions = this.all_inscriptions;
    });
  },
  mounted() {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();

    this.order_date = yyyy + '-' + mm + '-' + dd;
  },
  methods: {
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    createInscription() {
      var database = firebase.firestore();
      
      var newInscription = {
        id: '',
        sales: this.user,
        order_number: this.new_order_number,
        order_date: this.order_date,
        deposit_date: '',
        request_proof_date: '',
        comfirm_proof_date: '',
        customer_sign_date: '',
        sent_signed_proof_date: '',
        complete_date: '',
        status: '',
        files: [],
      }

      var newInscriptionRef = database.collection("inscriptions").doc();

      newInscription.id = newInscriptionRef.id;
      newInscription.status = 'active';
      newInscriptionRef.set(newInscription);

      this.hideModal('create-inscription');
    },
    showDetails(id) {
      this.$emit('showInscriptionDetails', id);
    },
  }
}
</script>
